module.exports = __webpack_public_path__ + "img/sub_event_icon2.b9e3163e.svg";